var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDdproduct(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 24 24",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    stroke: "#303c42",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "m.5 3.5s7 3 23 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.5 5.595602v4.904398l2.5-1 2.5 1v-4.3414469"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.5 6.350358v5.149642l2.5-1 2.5 1v-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1.5 3.8593838v5.6406162l2.5-1 2.5 1v-4.4023595"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.5 12.5s-7 3-23 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.5 14.595602v4.904398l-2.5-1-2.5 1v-4.3414469"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.5 15.350358v5.149642l-2.5-1-2.5 1v-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22.5 12.8593836v5.6406164l-2.5-1-2.5 1v-4.402359"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDdproduct);
export default __webpack_public_path__ + "static/media/ddproduct.a8afe0af2f46642b258e2da2ace74c2d.svg";
export { ForwardRef as ReactComponent };